import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Stethoscope } from "lucide-react";
import axios from "axios";
import { API_BASE } from "../lib/api";

export default function Login() {
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.from || "/";
    const [branding, setBranding] = useState(null);

    useEffect(() => {
        axios
            .get(`${API_BASE}/public/branding`)
            .then((res) => setBranding(res.data))
            .catch(() => {});
    }, []);
    const [email, setEmail] = useState("admin@rs.local");
    const [password, setPassword] = useState("admin123");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) navigate(redirectTo, { replace: true });
    }, [user, navigate, redirectTo]);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Selamat datang!");
            navigate(redirectTo, { replace: true });
        } else {
            toast.error(res.error);
        }
    }

    return (
        <div className="min-h-screen bg-[#F7F9F6] flex items-center justify-center px-6">
            <div className="grid md:grid-cols-2 gap-0 max-w-4xl w-full surface-card overflow-hidden">
                <div className="hidden md:flex flex-col justify-between p-10 bg-[#245B4B] text-white">
                    <div>
                        <div className="flex items-center gap-3 mb-6">
                            {branding?.logo_url ? (
                                <img
                                    src={branding.logo_url}
                                    alt="Logo RS"
                                    data-testid="login-logo"
                                    className="h-12 w-12 object-contain bg-white rounded-md p-1"
                                />
                            ) : (
                                <Stethoscope size={28} />
                            )}
                            <div className="font-heading font-semibold text-lg text-white">
                                {branding?.name || "MCU Calculator"}
                            </div>
                        </div>
                        <h1 className="font-heading text-3xl font-semibold leading-tight mb-3 text-white">
                            Kalkulator Paket Medical Check Up
                        </h1>
                        <p className="text-[#C4DAD2] text-sm leading-relaxed">
                            Kelola master pemeriksaan laboratorium & radiologi, hitung unit cost secara transparan,
                            dan hasilkan proposal paket MCU dengan kop surat resmi rumah sakit.
                        </p>
                    </div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#C4DAD2]">
                        Untuk penggunaan internal manajemen RS
                    </div>
                </div>

                <div className="p-8 md:p-10">
                    {branding?.logo_url && (
                        <img
                            src={branding.logo_url}
                            alt="Logo RS"
                            data-testid="login-logo-mobile"
                            className="h-14 object-contain mb-4 md:hidden"
                        />
                    )}
                    <h2 className="font-heading text-2xl font-semibold mb-1">Masuk</h2>
                    <p className="text-sm text-[#4A5E57] mb-6">
                        Gunakan akun admin rumah sakit Anda.
                    </p>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                data-testid="login-email-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="mt-1"
                            />
                        </div>
                        <div>
                            <Label htmlFor="password">Password</Label>
                            <Input
                                id="password"
                                type="password"
                                data-testid="login-password-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="mt-1"
                            />
                        </div>
                        <Button
                            type="submit"
                            data-testid="login-submit-btn"
                            disabled={loading}
                            className="w-full bg-[#245B4B] hover:bg-[#1A4236] text-white"
                        >
                            {loading ? "Memproses..." : "Masuk"}
                        </Button>
                        <div className="text-xs text-[#6A9C89] text-center pt-2">
                            Default: admin@rs.local / admin123
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
